import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ReactiveBase } from '@appbaseio/reactivesearch';
import Dashboard from '../pages/Dashboard';
import Platform from '../pages/Platform';
import Login from '../pages/Login';

import { APP, CRED, URL } from '../constants';
import Game from '../pages/Game';
import Wrapper from '../pages/Wrapper';

const AuthenicatedRoute = props => {
	const { auth } = props;
	return auth.isAuthenticated() ? (
		<Wrapper auth={auth}>
			<ReactiveBase
				app={APP}
				credentials={CRED}
				theme={{ colors: { primaryColor: '#3f51b5' } }}
				url={URL}
				enableAppbase
			>
				<Switch>
					<Route exact path="/" component={Dashboard} />
					<Route exact path="/platform" component={Platform} />
					<Route exact path="/game/:id" component={Game} />
					<Route
						exact
						path="/login"
						render={passedProps => <Login {...passedProps} auth={auth} />}
					/>
				</Switch>
			</ReactiveBase>
		</Wrapper>
	) : (
		<Route render={passedProps => <Login {...passedProps} auth={auth} />} />
	);
};

export default AuthenicatedRoute;
